import instance from "@/utils/request"
import openApiHttp from "@/utils/request2"
export let indexClickRank = () => {
    return instance({
        url: "/book/listClickRank",
    })
}
export let indexFinishRank = () => {
    return instance({
        url: "/book/listFinishClickRank",
    })
}
export let indexNewRank = () => {
    return instance({
        url: "/book/listNewRank",
    })
}
export let indexUpdateRank = (params) => {
    return instance({
        url: "/book/listUpdateRank",
        params,
    })
}
export let indexData = () => {
    return instance({
        url: "/book/listBookSetting",
    })
}
export let indexnews = () => {
    return instance({
        url: "/news/listIndexNews",
    })
}
export let indelimit = () => {
    return instance({
        url: "/book/queryTimeFreeList",
        params: {}
    })
}
export let CompletedRank = () => {
    return instance({
        url: "/book/listCompletedRank",
    })
}
export let websocket = () => {
    return instance({
        url: "/book/queryCommentCount",
    })
}